// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","content":"footer_content__1LQLH","left":"footer_left__F-xRq","lineItem":"footer_lineItem__39OiQ","popup":"footer_popup__kQPMT"};